import type { CityConfig } from "../city-template/types";

export const bellevueConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — WA Dept of Health Vital Records", href: "https://doh.wa.gov/licenses-permits-and-certificates/vital-records", description: "Official Washington vital records office in Tumwater" },
    { label: "Marriage Licenses — King County Recorder", href: "https://www.kingcounty.gov/depts/records-licensing.aspx", description: "King County Recorder — marriage license issuance" },
    { label: "Divorce Records — King County Superior Court Clerk", href: "https://www.kingcounty.gov/courts/clerk.aspx", description: "King County Superior Court Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of WA DOH for online vital record orders" },
  ],
  city: "Bellevue",
  state: "Washington",
  stateAbbr: "WA",
  slug: "bellevue",
  route: "/bellevue",
  title: "Emergency Passport Bellevue WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Bellevue, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Bellevue, Redmond, Kirkland, and all Eastside residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Bellevue, WA",
  heroSubtitle: "Bellevue travelers — from Microsoft and tech corridor professionals to affluent Eastside families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of the Eastside and King County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Bellevue%20Washington%20downtown%20with%20modern%20glass%20skyscrapers%2C%20the%20Bellevue%20skyline%2C%20Lake%20Washington%20waterfront%2C%20downtown%20park%20with%20lush%20greenery%2C%20wealthy%20suburban%20Eastside%20atmosphere%2C%20modern%20Pacific%20Northwest%20architecture%2C%20warm%20golden%20afternoon%20sunlight%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=bellevue-hero-001&orientation=landscape",
  heroImageAlt: "Bellevue Washington downtown skyline with modern skyscrapers and Lake Washington waterfront",
  geoPosition: "47.6101;-122.2015",
  geoPlacename: "Bellevue, Washington",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "Approximately 12 miles west of Bellevue via I-90 or SR-520",
  },
  nearbyCitiesZips: [
    { name: "Bellevue", zips: "98004, 98005, 98006, 98007, 98008, 98009, 98015" },
    { name: "Redmond", zips: "98052, 98053, 98073" },
    { name: "Kirkland", zips: "98033, 98034, 98083" },
    { name: "Renton", zips: "98055, 98056, 98057, 98058, 98059" },
    { name: "Issaquah", zips: "98027, 98029, 98075" },
    { name: "Mercer Island", zips: "98040" },
    { name: "Sammamish", zips: "98074, 98075" },
    { name: "Bothell", zips: "98011, 98012, 98021, 98041" },
    { name: "Woodinville", zips: "98072, 98077" },
    { name: "Newcastle", zips: "98056, 98059" },
    { name: "Snoqualmie", zips: "98065" },
    { name: "North Bend", zips: "98045" },
    { name: "Fall City", zips: "98024" },
    { name: "Carnation", zips: "98014" },
    { name: "Duvall", zips: "98019" },
    { name: "Clyde Hill", zips: "98004" },
    { name: "Yarrow Point", zips: "98004" },
    { name: "Hunts Point", zips: "98004" },
    { name: "Medina", zips: "98039" },
    { name: "Beaux Arts Village", zips: "98004" },
    { name: "Kenmore", zips: "98028" },
    { name: "Lake Forest Park", zips: "98155" },
    { name: "Shoreline", zips: "98133, 98155, 98160, 98177" },
    { name: "Lynnwood", zips: "98036, 98037, 98046, 98087" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — just 20 minutes across the lake" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Eastside Tech Corridor", desc: "Serving Microsoft, Amazon, and Eastside tech professionals" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Eastside location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Seattle, WA", route: "/seattle" },
    { name: "Emergency passport help in Redmond, WA", route: "/seattle" },
    { name: "Urgent passport services in Tacoma, WA", route: "/tacoma" },
    { name: "Washington passport services overview", route: "/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Bellevue, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — just 20 minutes across Lake Washington via SR-520 or I-90. Bellevue residents can ship from any UPS or FedEx on the Eastside.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Bellevue, Redmond, Kirkland, Renton, Issaquah, Mercer Island, Sammamish, Bothell, Woodinville, Newcastle, and all of the Eastside and eastern King County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Bellevue and the Eastside. From downtown Bellevue's tech corridor near Microsoft and the Bellevue Collection to the Sammamish Plateau, from the shores of Lake Washington in Kirkland to the Snoqualmie Valley — we serve all of the Eastside and eastern King County.",
  nearbyCitiesIntro: "We serve Bellevue and all nearby communities including Redmond, Kirkland, Renton, Issaquah, Mercer Island, Sammamish, Bothell, Woodinville, Newcastle, Snoqualmie, North Bend, Fall City, Carnation, Duvall, Clyde Hill, Medina, Kenmore, and Shoreline. We also serve Snohomish County and northern King County.",
  howItWorksIntro: "Most Bellevue travelers complete everything online and ship documents overnight. No need to drive across the lake to Seattle — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Bellevue is the Eastside's largest city with significant international travel from Microsoft, Amazon, and tech professionals. Here are the most common passport mistakes we see from Eastside travelers.",
  testimonialsIntro: "Bellevue travelers — from tech executives to families to Eastside professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Bellevue, WA? Here are the most common ones we hear from Eastside travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close Eastside proximity", "No bridge traffic or downtown parking hassle", "Perfect for tech and corporate travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close Eastside proximity", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive across Lake Washington to Seattle", "SR-520 bridge traffic and downtown parking"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Bellevue travelers with immediate departure needs — as fast as 24 hours. Our couriers handle the Seattle agency delivery. Perfect for last-minute tech conferences, Asia-Pacific business trips, and family emergencies.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — close Eastside courier", "Eastside tech and corporate travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Bellevue adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Eastside address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Bellevue residents and families — including new citizens, tech workers, and Eastside families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Bellevue residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Bellevue and Eastside families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Bellevue and Eastside residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Bellevue WA", description: "Urgent passport processing for Bellevue Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Bellevue WA", description: "Fast passport renewal for Bellevue Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Bellevue WA", description: "New passport application services for Bellevue Washington residents applying for their first passport." },
    { name: "Child Passport Bellevue WA", description: "Minor passport services for Bellevue Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "Andrew L.",
      location: "Bellevue, WA",
      rating: 5,
      text: "Conference in Singapore in 5 days and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Bellevue Way and the whole process was seamless. Outstanding.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Sophia T.",
      location: "Redmond, WA",
      rating: 5,
      text: "Family vacation to Japan with 8 days notice. Four passports — two adult renewals and two first-time for our kids. Done in 5 days. We shipped from FedEx on 148th and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Kevin M.",
      location: "Kirkland, WA",
      rating: 5,
      text: "Business trip to London with 10 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is an absolute game-changer for the Eastside.",
      service: "Emergency Passport",
    },
    {
      name: "Lisa C.",
      location: "Mercer Island, WA",
      rating: 5,
      text: "Lost my passport the week before a cruise to the Mediterranean. Fast Passport Center replaced it in 48 hours. The close proximity to Seattle made all the difference.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "bel-1",
      name: "Bellevue Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1801 136th Pl NE",
      city: "Bellevue",
      state: "WA",
      zip: "98005",
      phone: "(425) 462-0125",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Bellevue, near Overlake area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Bellevue acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to Microsoft and Eastside tech corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "bel-2",
      name: "Redmond Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7241 185th Ave NE",
      city: "Redmond",
      state: "WA",
      zip: "98052",
      phone: "(425) 885-1121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Redmond, approximately 6 miles northeast of Bellevue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Redmond, Microsoft campus, and northeast Eastside residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "bel-3",
      name: "Kirkland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11133 120th Ave NE",
      city: "Kirkland",
      state: "WA",
      zip: "98033",
      phone: "(425) 822-5131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Kirkland, approximately 5 miles north of Bellevue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Kirkland, Juanita, and north Eastside communities. Good alternative for north-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "bel-4",
      name: "Issaquah Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 NW Gilman Blvd",
      city: "Issaquah",
      state: "WA",
      zip: "98027",
      phone: "(425) 392-4513",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Issaquah, approximately 12 miles east of Bellevue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Issaquah, Sammamish, and the Snoqualmie Valley. Serves the eastern Eastside communities.",
      icon: "ri-mail-line",
    },
    {
      id: "bel-5",
      name: "King County Clerk — Eastside",
      type: "County Clerk Passport Acceptance",
      address: "516 3rd Ave, Room W-105",
      city: "Seattle",
      state: "WA",
      zip: "98104",
      phone: "(206) 477-3080",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Seattle Courthouse — across the lake",
      website: "https://www.kingcounty.com/depts/courts/clerk.aspx",
      websiteLabel: "King County Clerk",
      notes: "County Clerk passport acceptance. Extended hours compared to post office. Eastside residents may prefer the Bellevue or Redmond post offices for convenience.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — bridge traffic to downtown Seattle", fpc: "No — ship from Bellevue" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Tech Corridor Advantage", agency: "No special guidance", fpc: "Yes — Asia-Pacific travel expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Bellevue tech professionals and executives often discover passport issues just before international conferences. Asia-Pacific business travel peaks year-round. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services on Bellevue Way or in the Factoria area sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at King County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Bellevue Post Office appointments fill during summer and tech conference seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating SR-520 Bridge Traffic",
      description: "Many Bellevue residents attempt to drive to the Seattle passport agency in an emergency. SR-520 bridge traffic and tolls can turn a simple errand into a full morning — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Tech conference and Asia-Pacific travel demand is constant on the Eastside — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere on the Eastside." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Bellevue, Redmond, or Kirkland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — no need to cross the bridge yourself." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Bellevue address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Bellevue, WA?", a: "Fast Passport Center offers emergency passport processing in Bellevue, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — just 20 minutes across Lake Washington via SR-520 or I-90." },
    { q: "Does Bellevue have its own passport agency?", a: "No — Bellevue does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 20 minutes west via SR-520 or I-90). Fast Passport Center's courier service means Bellevue residents never need to deal with bridge traffic and downtown parking." },
    { q: "Can I get an expedited passport in Redmond, Kirkland, or Issaquah?", a: "Absolutely. Fast Passport Center serves all of the Eastside including Redmond, Kirkland, Issaquah, Mercer Island, Sammamish, Bothell, Woodinville, and Newcastle. Our service works the same way everywhere." },
    { q: "What airport do Bellevue travelers use for international flights?", a: "Seattle-Tacoma International Airport (SEA) is the primary airport for Bellevue and the Eastside. SEA is 20–25 minutes via I-90 or SR-520 and offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines are major hubs. Always verify passport validity for at least 6 months past your return date." },
    { q: "Can I use the Seattle passport agency for Asia-Pacific business travel?", a: "Yes. The Seattle Passport Agency processes emergency passports for travelers with confirmed departures within 14 days. Seattle is a major gateway to Asia and the Pacific. Fast Passport Center's couriers are experienced with Asia-Pacific travel deadlines and documentation requirements." },
    { q: "How much does an expedited passport cost in Bellevue, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Bellevue?", a: "Walgreens, CVS, and Bartell Drugs stores throughout Bellevue and Redmond offer passport photos. UPS Store and FedEx Office locations also provide them. Many locations on Bellevue Way and in the Factoria area offer walk-in service. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Microsoft employees?", a: "Yes. Fast Passport Center serves all of the Eastside including Microsoft employees and their families. We understand corporate travel schedules and can accommodate urgent business travel to Asia-Pacific and Europe. Our courier service is especially valuable for busy professionals who can't take a day off." },
  ],
  photoLocations: [
    { name: "Walgreens — Bellevue Way", address: "1060 Bellevue Way NE, Bellevue, WA 98004", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "Bartell Drugs — Factoria", address: "4058 Factoria Blvd SE, Bellevue, WA 98006", hours: "Mon–Sun: 7AM–10PM", website: "https://www.bartelldrugs.com/" },
    { name: "UPS Store — Redmond", address: "16150 NE 85th St, Redmond, WA 98052", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Bellevue", address: "10600 NE 8th St, Bellevue, WA 98004", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "WA DOL — Bellevue", address: "13133 NE 20th St, Bellevue, WA 98005", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Redmond", address: "14724 NE 31st St, Bellevue, WA 98007", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Redmond and northeast Eastside. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "20–25 minutes from Bellevue via SR-520 or I-90",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Primary airport for Bellevue and the Eastside. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub. Asia-Pacific gateway with direct flights to Tokyo, Seoul, Beijing, Singapore, and more.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: true,
    },
    {
      code: "BFI",
      name: "King County International Airport (Boeing Field)",
      distance: "Approximately 15 minutes from Bellevue via I-90",
      address: "7277 Perimeter Rd S, Seattle, WA 98108",
      note: "General aviation and cargo airport. Not typically used for international passenger travel. Serves Boeing and corporate aviation.",
      flightUrl: "https://www.kingcounty.gov/depts/transportation/kcia.aspx",
      flightLabel: "BFI Info",
      featured: false,
    },
    {
      code: "PAE",
      name: "Paine Field (Snohomish County)",
      distance: "Approximately 35 minutes north of Bellevue via I-405",
      address: "3220 100th St SW, Everett, WA 98204",
      note: "Commercial flights to select domestic destinations. Alaska Airlines and United serve Paine Field. Alternative to SEA for some domestic travel.",
      flightUrl: "https://www.painefield.com/",
      flightLabel: "PAE Flight Info",
      featured: false,
    },
  ],
};